import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { USER_CHANNELS_API } from '../../../constants/central-api';

export default async function get_communication_channels_api_call() {
  const userID = store.getState().user.profile?.user_id;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: USER_CHANNELS_API(userID),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      // 'Content-type': 'application/x-www-form-urlencoded',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_USER_CHANNELS';
  const customMsg = 'User channels fetched successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;

  if (res.actionType === actionType && response.success === true) {
    return response?.data || [];
  }
  return [];
}
